import { Box } from '@mui/material'

import { useHeaderContext } from '@/hooks/useHeaderContext'

import type { FC, PropsWithChildren } from 'react'

interface MegaMenuPanelProps extends PropsWithChildren {
  nodeId: string
}

export const MegaMenuPanel: FC<MegaMenuPanelProps> = ({ nodeId, children }) => {
  const { selectedMenuItem, megaMenuRef, isMegaMenuOpen } = useHeaderContext()
  const isSelected = selectedMenuItem === nodeId

  return (
    <Box
      ref={isSelected ? megaMenuRef : null}
      id={nodeId}
      sx={{
        margin: 'auto',
        position: 'absolute',
        bottom: !isMegaMenuOpen ? 0 : 'auto',
        top: isMegaMenuOpen ? 0 : 'auto',
        left: 0,
        right: 0,
        backgroundColor: 'background.default',
        visibility: isSelected ? 'visible' : 'hidden',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  )
}
